export default __webpack_public_path__ + "static/backgroundTeamInv-74feb9618b453e51e27aeefaf1155b8a.png";